module.exports = require('./lib/linkify-html').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/html.js
// module id = 441
// module chunks = 0